import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AppRoutingModule } from './../../app-routing.module';
import { WizardTileComponent } from './wizard-tile/wizard-tile.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ContinueButtonComponent } from './continue-button/continue-button.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { WizardNavigationComponent } from './wizard-navigation/wizard-navigation.component';
import { MoreInfoComponent } from './more-info/more-info.component';

@NgModule({
  imports: [
    CommonModule,
    AppRoutingModule,
    MatCardModule,
    MatIconModule,
    MatRippleModule,
    MatButtonModule,
    MatTooltipModule
  ],
  declarations: [
    WizardTileComponent,
    ProgressBarComponent,
    ContinueButtonComponent,
    BackButtonComponent,
    WizardNavigationComponent,
    MoreInfoComponent,
  ],
  exports: [
    WizardTileComponent,
    ProgressBarComponent,
    ContinueButtonComponent,
    BackButtonComponent,
    WizardNavigationComponent,
    MoreInfoComponent
  ]
})
export class SharedModule {}
